import React from 'react'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'

import InvitationsForm from '../components/invitations/InvitationsForm'
import useUsersApi from '../hooks/users/useUsersApi'

export default function CreateInvitationPage({ building }) {
  const history = useHistory()
  const [_, methods] = useUsersApi()

  return (
    <InvitationsForm
      onSubmit={(values) => {
        methods.createInvitation(values)
      }}
      handleCancel={() => history.push('/invitaciones')}
      building={building}
    />
  )
}
